import React from 'react';
import { BodyCell, DataGrid } from '@tableau/widgets-datagrid';
import { StyledCellFormatter } from '../StyledCellWrapper';
import { ExplorerStyles } from '../../Explorer/ExplorerStyles';
import * as CertificationWatermark from '@tableau/certification-watermark';

export interface ContentTypeCellOptions {
  imageUrlForRow: (row: DataGrid.Row) => string;
  titleForIcon: (row: DataGrid.Row) => string;
  isCertified: (row: DataGrid.Row) => boolean;
  getTooltipProps: (row: DataGrid.Row) => CertificationWatermark.CertificationTooltipProps;
}

export const ContentTypeCell = (options: ContentTypeCellOptions): React.StatelessComponent<BodyCell.Props> => {
  return StyledCellFormatter(
      React.createFactory(class extends React.Component<BodyCell.Props, any> {
        public render(): JSX.Element {

          const icon = <img src={options.imageUrlForRow(this.props.row)} className={ExplorerStyles.ContentTypeCellImg}
                            alt={options.titleForIcon(this.props.row)} title={options.titleForIcon(this.props.row)}/>;
          let iconWrapper;

          if (options.isCertified(this.props.row)) {
            const tooltipProps = {...options.getTooltipProps(this.props.row), icon: icon};
            iconWrapper = <CertificationWatermark.CertificationTooltipComponent {...tooltipProps} />;
          } else {
            iconWrapper = icon;
          }

          return (
              <div className={ExplorerStyles.ContentTypeCellContainer}>
                {iconWrapper}
              </div>
          );
        }
      })
  );
};
